import { motion } from "framer-motion";
import { fadeUp, viewport } from "@/lib/motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLang } from "@/context/LanguageContext";

export const FAQ = () => {
  const { t } = useLang();
  const f = t.faq;
  return (
    <section id="faq" className="py-24 md:py-32 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <motion.p variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport} className="overline text-[#C4A484] mb-5">{f.overline}</motion.p>
          <motion.h2 variants={fadeUp} custom={1} initial="hidden" whileInView="show" viewport={viewport} className="font-serif text-4xl md:text-5xl leading-[0.95] tracking-tight text-[#0D2A27]">{f.heading}</motion.h2>
        </div>

        <motion.div variants={fadeUp} custom={2} initial="hidden" whileInView="show" viewport={viewport} className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {f.items.map((item, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-[#E2E0D8]">
                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left font-serif text-xl md:text-2xl text-[#0D2A27] hover:no-underline py-6">{item.q}</AccordionTrigger>
                <AccordionContent className="text-[#555] text-base leading-relaxed pb-6 max-w-2xl">{item.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};
